export default "__VITE_ASSET__BW7NBuih__"